<template>

    <div id="statistics-admin">

        <div class="container">

            <div class="row">

                <div class="col-12">

                    <div class="row">

                        <div class="col-12">

                            <div class="dropdown-menu-holder">
                                <!-- items -->
                                <div v-if="project.items.length" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-items" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.questions }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-items">

                                        <li v-for="(item, index) in project.items" :key="`item-${index}`" >
                                            <label>
                                                <input class="form-check-input" :disabled="disabledItems.includes(item.id)" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : item.id, 'type' : 'item'}" type="checkbox"  :id="`item-filter-${item.id}`"> {{ language?.question.replacePlaceholders({ number : index + 1 }) }} ({{ getTypeName(item)?.toLowerCase() }})
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- ages -->
                                <div v-if="project.hide_ages" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-ages" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.age }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-ages">

                                        <li v-for="(ageVal, index) in project.ages" :key="`age-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : ageVal.age, 'type' : 'age'}" type="checkbox"  :id="`age-filter-${ageVal.age}`"> {{ ageVal.age }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- genders -->
                                <div v-if="project.hide_sex" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-genders" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.gender }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul v-if="project.genders.length" class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-genders">

                                        <li v-for="(gender, index) in project.genders" :key="`gender-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : gender.gender, 'type' : 'gender'}" type="checkbox"  :id="`gender-filter-${gender.id}`"> {{ gender.gender }}
                                            </label>
                                        </li>
                                    </ul>

                                    <ul v-if="!project.genders.length"  class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-genders">
                                        <li>
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : language?.female , 'type' : 'gender'}" type="checkbox"  :id="`gender-filter-woman`"> {{ language?.female }}
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : language?.male, 'type' : 'gender'}" type="checkbox"  :id="`gender-filter-man`"> {{ language?.male }}
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : language?.other, 'type' : 'gender'}" type="checkbox"  :id="`gender-filter-other`"> {{ language?.other }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- types -->
                                <div v-if="project.hide_types" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-types" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.type }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-types">

                                        <li v-for="(type, index) in project.types" :key="`type-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : type.type, 'type' : 'type'}" type="checkbox"  :id="`type-filter-${type.id}`"> {{ type.type }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- counties -->
                                <div v-if="project.hide_counties" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-counties" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.county }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-counties">

                                        <li v-for="(county, index) in project.counties" :key="`type-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : county.name, 'type' : 'county'}" type="checkbox"  :id="`county-filter-${county.id}`"> {{ county.name }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- good/bad   -->
                                <div v-if="project.allow_good_and_bad_options" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-good-bad" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.good }}/{{ language?.improve }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-good-bad">

                                        <li v-if="project.allow_good_options">
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : 'good', 'type' : 'goodbad'}" type="checkbox"  :id="`goodbad-filter-1`"> {{ language?.good }}
                                            </label>
                                        </li>

                                        <li v-if="project.allow_bad_options">
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : 'bad', 'type' : 'goodbad'}" type="checkbox"  :id="`goodbad-filter-2`"> {{ language?.improve }}
                                            </label>
                                        </li>

                                    </ul>

                                </div>

                                <!-- good -->
                                <div v-if="project.allow_good_options && goodOptions.length > 0" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-good" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.good }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-good">

                                        <li v-for="(good, index) in goodOptions" :key="`type-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : good, 'type' : 'good'}" type="checkbox"  :id="`good-filter-${good.id}`"> {{ good.value }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- bad -->
                                <div v-if="project.allow_bad_options && badOptions.length > 0" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-bad" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.improve }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-bad">

                                        <li v-for="(bad, index) in badOptions" :key="`type-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : bad, 'type' : 'bad'}" type="checkbox"  :id="`bad-filter-${bad.id}`"> {{ bad.value }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                                <!-- scale -->
                                <div v-if="hasScaleItems" class="dropdown">

                                    <button class="btn btn-default dropdown-toggle" type="button" id="project-scale" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ language?.scale }}
                                        <span class="caret"></span>
                                    </button>

                                    <ul class="dropdown-menu checkbox-menu allow-focus" aria-labelledby="project-scale">

                                        <li v-for="(scale, index) in scaleOptions" :key="`type-${index}`" >
                                            <label>
                                                <input class="form-check-input" v-on:change.prevent="getAdminChartData()" v-model="selectedFilters" :value="{'value' : scale, 'type' : 'scales'}" type="checkbox"  :id="`bad-filter-${scale.id}`"> {{ scale.value }}
                                            </label>
                                        </li>
                                    </ul>

                                </div>

                            </div>

                        </div>

                    </div>

                    <fragment v-if="chosenFilters">

                        <ul>

                            <fragment v-for="(value, name) in chosenFilters" :key="name">
                                <li v-if="value.length">
                                    <strong>{{ selectedFilterLabels(name) }}</strong> : {{ selectedFilterValues(value) }}
                                </li>
                            </fragment>

                        </ul>

                    </fragment>

                    <div class="total-info">
                        <div v-if="totalAnswersAmount">{{ language?.comments.replacePlaceholders({ number : totalAnswersAmount }) }}</div>
                        <div v-if="totalUsersAmount">{{ language?.participants.replacePlaceholders({ number : totalUsersAmount }) }}</div>
                        <div v-if="totalVisitorsAmount">{{ language?.visitors.replacePlaceholders({ number : totalVisitorsAmount }) }}</div>
                    </div>

                    <map-filter v-if="showMap" :filters="getFiltredValues" :slide="selectedItem" />

                    <image-filter v-if="showImage" :filters="getFiltredValues" :slide="selectedItem" />

                    <div class="row" :class="{ 'render-chart' : lineChartLoading }">

                        <div class="col-12">
                            <line-chart @total-users="totalUsers" @total-answers="totalAnwers" @total-visitors="totalVisitors" @line-chart-rendered="lineChartRendered" :project="project" :values="filtred ? getFiltredValues : null" />
                        </div>

                        <loading-screen v-if="lineChartLoading" />

                    </div>

                    <div v-if="!showCharts" class="row" :class="{ 'render-chart' : ! showCharts }">
                        <loading-screen  />
                    </div>

                    <div v-if="showCharts" class="row">
                        <div class="col-12">
                            <h2>{{ totalUsersAmount !== '' ? language?.participants_of.replacePlaceholders({ shown : currentUserAmount, total : totalUsersAmount }) : '' }}</h2>
                        </div>
                    </div>

                    <div v-if="showCharts" class="row users">

                        <div v-if="project.hide_ages && (isDefaultValues || (result !== null && Object.size(result.ages) > 0) )" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.age"></legend>
                            <output-stats :project="project" :legendvalue="language.participants_clean" :legendname="language.age" :values="result === null ? getFiltredValues : result" :slug="'ages'" />
                        </div>

                        <div v-if="project.hide_sex && (isDefaultValues || (result !== null && Object.size(result.genders) > 0) )" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.gender"></legend>
                            <output-stats :project="project" :legendvalue="language.participants_clean" :legendname="language.gender" :values="result === null ? getFiltredValues : result" :slug="'genders'" />
                        </div>

                        <div v-if="project.hide_types && (isDefaultValues || (result !== null && Object.size(result.types) > 0) )" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.type"></legend>
                            <output-stats :project="project" :legendvalue="language.participants_clean" :legendname="language.type" :values="result === null ? getFiltredValues : result" :slug="'types'" />
                        </div>

                        <div v-if="project.hide_counties && (isDefaultValues || (result !== null && Object.size(result.counties) > 0) )" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.county"></legend>
                            <output-stats :project="project" :legendvalue="language.participants_clean" :legendname="language.county" :values="result === null ? getFiltredValues : result" :slug="'counties'" />
                        </div>

                    </div>

                    <div v-if="showCharts && (isDefaultValues || (result !== null && (Object.size(result.scales) > 0 || Object.size(result.goodbad) > 0 || Object.size(result.good_types) > 0 || Object.size(result.bad_types) > 0 ) ))" class="row answers">
                        <div class="col-12">
                            <h2>{{ totalAnswersAmount !== '' ? language?.comments_of.replacePlaceholders({ shown : currentAnswersAmount, total : totalAnswersAmount }) : '' }}</h2>
                        </div>
                    </div>

                    <div v-if="showCharts" class="row">

                        <div v-if="hasScaleItems && (isDefaultValues || (result !== null && Object.size(result.scales) > 0))" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.scales"></legend>
                            <output-stats :project="project" :legendvalue="language.comments_clean" :legendname="language.scales" :values="result === null ? getFiltredValues : result" :slug="'scales'" />
                        </div>

                        <div v-if="project.allow_good_and_bad_options && (isDefaultValues || (result !== null && Object.size(result.goodbad) > 0))" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.goodbad"></legend>
                            <output-stats :project="project" :legendvalue="language.comments_clean" :legendname="language.goodbad" :values="result === null ? getFiltredValues : result" :slug="'goodbad'" :language="language" />
                        </div>

                        <div v-if="( project.allow_good_options && goodOptions.length > 0 ) && (isDefaultValues || ( result !== null && Object.size(result.good_types) > 0 ))" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.good"></legend>
                            <output-stats :project="project" :legendvalue="language.comments_clean" :legendname="language.good" :values="result === null ? getFiltredValues : result" :slug="'good_types'" />
                        </div>

                        <div v-if="( project.allow_bad_options && badOptions.length > 0 ) && (isDefaultValues || ( result !== null && Object.size(result.bad_types) > 0 ))" class="col-12 col-lg-6 chart-wrapper">
                            <legend v-html="language.bad"></legend>
                            <output-stats :project="project" :legendvalue="language.comments_clean" :legendname="language.bad" :values="result === null ? getFiltredValues : result" :slug="'bad_types'" />
                        </div>

                    </div>

                    <!-- <loading-screen v-else /> -->

                </div>
            </div>

        </div>

    </div>

</template>

<script>

import Chart from './chart/Chart'

import LineChart from './chart/LineChart'

import OutputStats from './chart/OutputStats'

import ImageFilter from './filter/ImageFilter'

import MapFilter from './filter/MapFilter'

import LoadingScreen from './LoadingScreen.vue'

import { Fragment } from 'vue-fragment'

export default {

    components: {

        Chart,

        OutputStats,

        LineChart,

        MapFilter,

        ImageFilter,

        LoadingScreen,

        Fragment

    },

    data() {

        return {

            selectedFilters : [],

            filtred : false,

            totalUsersAmount: '',

            currentUserAmount : '',

            totalAnswersAmount: '',

            totalVisitorsAmount: '',

            currentAnswersAmount : '',

            result : null,

            showCharts : false,

            disabledItems : [],

            showMap: false,

            showImage: false,

            selectedItem: null,

            debounce : null,

            debounceTimer : 1000,

            lineChartLoading : true,

            language : null

        }

    },

    mounted() {

        axios.get('/api/translations/admin-statistics')

        .then(res => {

            this.language = res.data

            this.getAdminChartData(true);

        })

        .catch(err => console.log(err))


    },

    props: {
        project: Object
    },

    computed: {

        items : function() {

            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'item').map(item => item.value);
            }

            return [];
        },

        ages : function() {

            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'age').map(item => item.value);
            }

            return [];
        },

        types : function() {

            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'type').map(item => item.value);
            }

            return [];
        },

        counties : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'county').map(item => item.value);
            }

            return [];
        },

        genders : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'gender').map(item => item.value);
            }

            return [];
        },

        good_types : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'good').map(item => item.value);
            }

            return [];
        },

        bad_types : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'bad').map(item => item.value);
            }

            return [];
        },

        scales : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'scales').map(item => item.value);
            }

            return [];
        },

        goodbad : function() {
            if(this.selectedFilters.length) {
                return this.selectedFilters.filter(item => item.type == 'goodbad').map(item => item.value);
            }

            return [];
        },

        goodOptions: function() {

            let options = [];

            this.project.items.forEach(item => {

                item.question.options.forEach(option => {

                    let obj = {
                        id : option.id,
                        value : option.value
                    }



                    if(option.type === 'good' && !options.some(o => o.id === obj.id)) {
                        options.push(obj)
                    }
                })
            });

            return options

        },

        badOptions: function() {

            let options = [];

            this.project.items.forEach(item => {

                item.question.options.forEach(option => {

                    let obj = {
                        id : option.id,
                        value : option.value
                    }

                    if(option.type === 'bad' && !options.some(o => o.id === obj.id)) {
                        options.push(obj)
                    }
                })
            });

            return options

        },

        scaleOptions: function() {

            let options = [];

            this.project.items.forEach(item => {

                item.question.options.forEach(option => {

                    let obj = {
                        id : option.id,
                        value : option.value
                    }

                    if(option.type === 'scale' && !options.some(o => o.id === obj.id)) {
                        options.push(obj)
                    }
                })
            });

            return options

        },

        getFiltredValues: function() {

            return {
                items: this.items,
                ages : this.ages,
                genders : this.genders,
                types : this.types,
                counties : this.counties,
                scales : this.scales,
                goodbad : this.goodbad,
                good_types : this.good_types,
                bad_types : this.bad_types
            }

        },

        isDefaultValues: function() {

            if(
                this.items.length === 0 &&
                this.ages.length === 0 &&
                this.genders.length === 0 &&
                this.types.length === 0 &&
                this.counties.length === 0 &&
                this.scales.length === 0 &&
                this.goodbad.length === 0 &&
                this.good_types.length === 0 &&
                this.bad_types.length === 0
            ) {
                this.filtred = false;
                return true;
            } else {
                return false
            }

        },

        hasScaleItems: function() {
            let scales = this.project.items.filter(item => item.type === 'question' && item.question.type === 'scale')
            return scales.length > 0 ? true : false
        },

        chosenFilters: function() {

            if(this.selectedFilters.length) {

                const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {})

                let values = groupByKey(this.selectedFilters,'type')

                return values
            }

            return false
        }
    },

    methods: {

        lineChartRendered: function() {
            this.lineChartLoading = false
        },

        totalUsers: function(e) {
            this.totalUsersAmount = e.total;
            this.currentUserAmount = e.current;
        },

        totalAnwers: function(e) {
            this.totalAnswersAmount = e.total;
            this.currentAnswersAmount = e.current;
        },

        totalVisitors: function(amount) {
            this.totalVisitorsAmount = amount;
        },

        getAdminChartData: function(initial = false) {
            // check if one item in filter
            const checkItems = this.selectedFilters.filter(filter => filter.type === 'item').map(item => item.value)

            this.disabledItems = []

            this.showMap = false

            this.showImage = false

            if(checkItems.length > 0) {

                const id = checkItems.pop()

                this.disabledItems = this.project.items.map(item => item.id).filter(item => item !== id)

                let maps = this.project.items.filter(item => item.type === 'map' && item.id === id)

                let images = this.project.items.filter(item => item.type === 'image' && item.id === id)

                if(maps.length) {
                    this.selectedItem = maps.pop()
                    this.showMap = true;
                }

                if(images.length) {
                    this.selectedItem = images.pop()
                    this.showImage = true;
                }

            }

            const time = initial ? 0 : this.debounceTimer

            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {

                axios.post(`/api/get-stats-admin`,{ project: this.project.id, values : this.getFiltredValues })

                .then((res) => {
                    if(res.data) {
                        this.result = res.data;
                        this.filtred = true;
                        this.showCharts = true;
                    }
                })
                .catch((err) => {
                    console.error(err);
                })

            }, time)

        },

        getTypeName: function(item) {

            if(item.type === 'map' || item.type === 'image') {
                return this.language?.[item.type];
            } else {
                return this.language?.[item.question.type];
            }

        },

        getItemName: function(id) {

            if(!this.project.items) return

            const items = this.project.items
            const item = items.find(item => item.id === id)
            const index = items.findIndex(x => x.id === id)

            return `${this.language.question.replacePlaceholders({ number : index + 1 })} (${this.getTypeName(item)?.toLowerCase()})`
        },

        selectedFilterLabels(key) {
            return this.language?.[key]
        },

        selectedFilterValues(value) {

            value = value.map(item => {

                if( item === 'good' || item.value && item.value === 'good' ) {
                    return this.language?.good
                }

                if( item === 'bad' || item.value && item.value === 'bad' ) {
                    return this.language?.bad
                }

                if(typeof item.value === 'object') {
                    return item.value.value
                }

                if(item.type === 'item') {
                    return this.getItemName(item.value)
                }

                return item.value
            } )

            return value.join(', ')
        }


    }
};
</script>

